export default "__VITE_PUBLIC_ASSET__03680863__"